import styled from "styled-components";

export const FormWrapper = styled.div`
    // width: 900px; // For Fix-Width
    display: flex;
    flex-wrap: wrap;
`;
